import React from "react";

export default function Step4() {
  return (
    <div>
      <div className="flex gap-2.5">
        <div className="shrink-0 border border-icon/50 w-8 h-8 rounded-full flex justify-center items-center text-lg font-semibold text-icon">
          4
        </div>
        <h1 className="">
          Em seguida, clique em <b>ACEITAR TUDO</b>.
        </h1>
      </div>
      <div className="mt-2.5 ml-[42px]">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/steady-gainz.firebasestorage.app/o/OpenAccount%2FIMG_3607.jpg?alt=media&token=ca3f3311-262c-41aa-ad4d-d6976b2960f4"
          className="w-72"
          alt=""
        />
      </div>
    </div>
  );
}
